import { Link, useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import Logo from './blueprint/Logo'
import { INVITE_HREF } from './blueprint/ui'

const navLink = 'bp-focus rounded-md px-3 py-1.5 font-display text-sm text-slate-400 transition-colors duration-150 hover:bg-white/[0.04] hover:text-slate-100'

export default function LandingNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isSubPage = pathname !== '/'

  return (
    <nav className="fixed left-0 right-0 top-0 z-50 h-14 border-b border-white/[0.07] bg-[#030712]/75 backdrop-blur-md">
      <div className="mx-auto flex h-full max-w-[1200px] items-center justify-between px-5 md:px-6">
        <div className="flex items-center gap-6">
          {isSubPage && (
            <button onClick={() => navigate(-1)} className="bp-focus flex items-center gap-1.5 font-mono text-xs text-slate-500 transition-colors hover:text-cyan-400">
              <ArrowLeft className="h-3.5 w-3.5" />
              Back
            </button>
          )}
          <Link to="/" className="bp-focus" aria-label="GCodr home"><Logo /></Link>
          <div className="hidden items-center md:flex">
            <a href="/#how" className={navLink}>How it works</a>
            <a href="/#features" className={navLink}>Features</a>
            <a href="/#cadable" className={navLink}>CADable</a>
            <Link to="/docs" className={navLink}>Docs</Link>
            <Link to="/pricing" className={navLink}>Pricing</Link>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => navigate('/login')} className="bp-focus rounded-md px-3 py-1.5 font-display text-sm text-slate-300 transition-colors duration-150 hover:text-slate-50">
            Sign in
          </button>
          <a href={INVITE_HREF} className="bp-focus inline-flex h-8 items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 px-3.5 font-display text-sm font-semibold text-gray-950 transition-colors duration-150 hover:from-cyan-400 hover:to-blue-400">
            Request an invite
          </a>
        </div>
      </div>
    </nav>
  )
}
